import { client } from 'src/api/main/client.gen'

/**
 * Thin local wrapper around the email-OTP endpoints. These will be replaced
 * by generated calls from `npm run openapi` once the backend schema is
 * deployed with the new `/authorization/token/otp/*` paths.
 */

export type EmailOtpRequestBody = {
  username: string
  service_token?: string
  domain_name?: string
  redirect_url?: string
}

export type EmailOtpRequestResponse = {
  sent: boolean
  masked_destination: string
  expires_in: number
  wait: number
  otp_access_token: string | null
}

export type EmailOtpVerifyBody = {
  otp_code: string
}

export type EmailOtpVerifyResponse = {
  access: string
  refresh: string
  status?: 'authenticated'
  organization_id?: number | null
}

export type EmailOtpLinkVerifyBody = {
  token: string
}

// hey-api's `client.post<TData>` expects `TData` to be a responses-shaped
// object (`{ 200: Response }`) — it internally unions `TData[keyof TData]`.
type EmailOtpRequestResponses = { 200: EmailOtpRequestResponse }
type EmailOtpVerifyResponses = { 200: EmailOtpVerifyResponse }

export const emailOtpRequest = (body: EmailOtpRequestBody) =>
  client.post<EmailOtpRequestResponses, unknown, true>({
    url: '/authorization/token/otp/request/',
    body,
    responseType: 'json',
    throwOnError: true
  })

export const emailOtpVerify = (body: EmailOtpVerifyBody, accessToken: string) =>
  client.post<EmailOtpVerifyResponses, unknown, true>({
    url: '/authorization/token/otp/verify/',
    body,
    headers: { Authorization: `Token ${accessToken}` },
    responseType: 'json',
    throwOnError: true
  })

export const emailOtpLinkVerify = (body: EmailOtpLinkVerifyBody) =>
  client.post<EmailOtpVerifyResponses, unknown, true>({
    url: '/authorization/token/otp/link/verify/',
    body,
    responseType: 'json',
    throwOnError: true
  })
